import i18next from "i18next";

const BASE_IMAGE_URL = "/wp-content/plugins/pottsalat/static/images";

const categories = [
    // {
    //     href: "/shop/salate/",
    //     content: i18next.t("header.lowerMenu.salads"),
    //     img: `${BASE_IMAGE_URL}/potti.webp`,
    //     slug: "salads",
    //     homepageOrder: 1,
    // },
    // {
    //     href: "/shop/bowls/",
    //     content: i18next.t("header.lowerMenu.bowls"),
    //     img: `${BASE_IMAGE_URL}/bowl.webp`,
    //     slug: "bowls",
    //     homepageOrder: 2,
    // },
    // {
    //     href: "/shop/suppen/",
    //     content: i18next.t("header.lowerMenu.soup"),
    //     img: `${BASE_IMAGE_URL}/ramen.webp`,
    //     slug: "soups",
    //     homepageOrder: 3,
    // },
    // {
    //     href: "/shop/brote/",
    //     content: i18next.t("header.lowerMenu.dips"),
    //     img: `${BASE_IMAGE_URL}/bread.webp`,
    //     slug: "dips",
    //     homepageOrder: 6,
    // },
    // {
    //     href: "/shop/desserts/",
    //     content: i18next.t("header.lowerMenu.desserts"),
    //     img: `${BASE_IMAGE_URL}/desserts.webp`,
    //     slug: "desserts",
    //     homepageOrder: 5,
    // },
    // {
    //     href: "/shop/getraenke/",
    //     content: i18next.t("header.lowerMenu.beverages"),
    //     img: `${BASE_IMAGE_URL}/drink.webp`,
    //     slug: "beverages",
    //     homepageOrder: 4,
    // },
];

export default categories;
